"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchVehicleVrnOnlyStepDefinition = void 0;
const WidgetFormStepPluginDefinition_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepPluginDefinition");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const WidgetFormStepBase_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepBase");
const VehicleOptionType_1 = require("../../../../Enum/VehicleOptionType");
const VehicleOption_1 = require("../../../../Model/VehicleOption");
const configs_1 = require("../../../../configs/configs");
const InchcapeInternalEvents_1 = require("../../../../Enum/InchcapeInternalEvents");
const SearchVehicleVrnOnlyForm_1 = require("../FormHandler/SearchVehicleVrnOnlyForm");
class SearchVehicleVrnOnlyStep extends WidgetFormStepBase_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider, repoFactory, returnLinkService, rmbHelper) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider);
        this.stateOptions = [];
        this.optionsInOrder = [
            VehicleOptionType_1.VehicleOptionType.STATE,
        ];
        this.optionsErrorLabels = ["state"];
        this.vehicleRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VEHICLE, { config: this.widgetConfig });
        this.returnLinkService = returnLinkService;
        this.rmbHelper = rmbHelper;
        configs_1.configs.addressState.forEach((residenceState) => {
            let stateOption = new VehicleOption_1.VehicleOption();
            stateOption.setId(residenceState.id).setLabel(residenceState.label);
            this.stateOptions.push(stateOption);
        });
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("plugin.provider.form_handler"), container.get("factory.repository"), container.get("return_link"), container.get("rmb_helper"));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.SEARCH_VEHICLE_VRN_ONLY).getTemplate();
    }
    /**
     * @inheritDoc
     */
    render() {
        let result = super.render();
        this.renderer.set("setSelectedOption", this.setSelectedOption.bind(this));
        this.renderer.set("searchManual", () => this.searchVehicleManually());
        return result;
    }
    /**
     * @inheritDoc
     */
    registerHandlers() {
        super.registerHandlers();
        let container = document.getElementById(this.widgetConfig.getContainerId());
        container.querySelector(configs_1.configs.elementIDs.vrm).addEventListener('blur', this.toggleVrmVerifier.bind(this));
        container.querySelector(configs_1.configs.elementIDs.vrm).addEventListener('focus', this.toggleVrmVerifier.bind(this));
        this.renderer.observe("vrm", (value) => this.state.setVrm(value));
    }
    /**
     * @inheritDoc
     */
    initialize() {
        return Promise.resolve().then(() => {
            this.container = document.getElementById(this.widgetConfig.getContainerId());
            this.state.setIncompleteInfo(false);
            this.state.setTriedVrm(false);
            this.state.setIsLoading(false);
            this.state.setIsAustraliaDistribution(this.rmbHelper.isAustraliaDistribution());
            let previousValuation = this.state.getValuation();
            if (previousValuation && previousValuation.getVrm()) {
                const vehicle = previousValuation.getVehicle() || this.state.getVehicles().get(0);
                this.state.setVrm(vehicle.getVrm());
                this.state.setVehicleOptions(VehicleOptionType_1.VehicleOptionType.STATE, this.stateOptions);
                this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.STATE, vehicle.getVehicleHistory().getRegistrationStatus().getRegistrationLocationCode());
            }
        });
    }
    /**
     * @inheritDoc
     */
    submit(data) {
        this.state.setIsLoading(true);
        this.state.setIncompleteInfo(false);
        return this.vehicleRepo.searchByVrn(data.vrm, data.state)
            .then((vehicles) => {
            this.state.setVehicles(vehicles);
            this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
        })
            .catch((error) => {
            var _a;
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                this.state.setVrnOnlySearchFailed(true);
                this.searchVehicleManually();
            }
            else {
                this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
            }
        })
            .finally(() => this.state.setIsLoading(false));
    }
    searchVehicleManually() {
        this.state.setVehicles(null);
        this.state.setVehicle(null);
        this.eventContext.emit(InchcapeInternalEvents_1.InchcapeInternalEvents.SET_STEP, StepTypes_1.StepTypes.SEARCH_VEHICLE_VRN_AND_DETAILS);
    }
    setSelectedOption(option) {
        this.state.setErrorStatus(false);
        this.state.setIncompleteInfo(false);
        let query = configs_1.configs.elementIDs[option];
        let selectedOption = this.container.querySelector(query).value;
        // The please select options have an value of empty string
        if (selectedOption !== '') {
            this.state.setVehicleOptionType(option, selectedOption);
            this.state.setVehicleOptionTypeLabel(option, this.getLabelForOption(option, selectedOption));
        }
    }
    getLabelForOption(option, selectedOption) {
        let optionsList = this.state.getVehicleOptions(option);
        for (let i = 0; i < optionsList.length; i++) {
            if (optionsList[i].getId() === selectedOption) {
                return optionsList[i].getLabel();
            }
        }
    }
    /**
     * @TODO: See if we still need this over the ractive observer.
     * @param event
     */
    toggleVrmVerifier(event) {
        const verifier = () => {
            const input = event.target;
            this.form.getFormValidator()
                .validateField(input.name, this.form.getValue(input.name))
                .then((errors) => this.togglePostVrmOptions(!errors));
        };
        if (this.vrmVerifierInterval) {
            verifier();
            clearInterval(this.vrmVerifierInterval);
            this.vrmVerifierInterval = null;
        }
        else {
            // Use intervals to check value in order to bypass the issue
            // of autocomplete selection not triggering change.
            this.vrmVerifierInterval = setInterval(verifier, 400);
        }
    }
    togglePostVrmOptions(show) {
        if (show) {
            this.state.setVehicleOptions(VehicleOptionType_1.VehicleOptionType.STATE, this.stateOptions);
            this.state.setCurrentOption(this.optionsErrorLabels[0]);
        }
        else {
            this.resetOptions();
            this.state.setVehicleOptionTypeLabel(VehicleOptionType_1.VehicleOptionType.STATE, '');
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.STATE, '');
            this.form.getFormValidationRenderer()
                .removeForField('state');
        }
    }
    resetOptions(option = null) {
        this.state.setErrorStatus(false);
        let index = this.optionsInOrder.indexOf(option);
        for (let i = index + 1; i < this.optionsInOrder.length; i++) {
            this.state.setVehicleOptionType(this.optionsInOrder[i], "");
            this.state.setVehicleOptions(this.optionsInOrder[i], null);
        }
    }
    /**
     * @inheritDoc
     */
    destroy() {
        return Promise.resolve().then(() => {
            clearInterval(this.vrmVerifierInterval);
            return super.destroy();
        });
    }
}
exports.default = SearchVehicleVrnOnlyStep;
exports.SearchVehicleVrnOnlyStepDefinition = new WidgetFormStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.SEARCH_VEHICLE_VRN_ONLY,
    class: SearchVehicleVrnOnlyStep,
    form_id: SearchVehicleVrnOnlyForm_1.SearchVehicleVrnOnlyFormDefinition.getId(),
    priority: 4000
});
